import { Button, Stack } from "@mui/material";
import LassoGrid from "../../components/LassoGrid";
import { useNavigate } from "react-router-dom";
import FeedIcon from "@mui/icons-material/Feed";
import { PublicationColumnDefinitions } from "./PublicationColumnDefinitions";
import { useGetPublicationsQuery } from "../../api/publicationApiSlice";
import { useState } from "react";
import PublicationDetails from "./components/PublicationDetails";


const Publications = () => {
    const [selectedRow, setSelectedRow] = useState<Record<string, any>>({});
    const [isDrawerOpen, setIsDrawerOpen] = useState(false);

    const navigate = useNavigate();
    const { data: publications } = useGetPublicationsQuery({});
    const navigateToAddPublications = () => {
        navigate("/publications/add")
    }

    const handleRowClick = (event: any) => {
        setSelectedRow(event.data);
        setIsDrawerOpen(true);
    };

    const handleCloseDrawer = () => {
        setIsDrawerOpen(false);
    };

    return (
        <Stack height="100%" gap={3}>
            <Stack>
                <Button
                    variant="primary"
                    sx={{ alignSelf: 'flex-end' }}
                    onClick={navigateToAddPublications}
                    startIcon={<FeedIcon/>}
                >
                    Add a publication
                </Button>
            </Stack>
            <PublicationDetails selectedPublication={selectedRow} isDrawerOpen={isDrawerOpen}
                handleCloseDrawer={handleCloseDrawer}/>
            <LassoGrid columns={PublicationColumnDefinitions}
                defaultColDef={{ filter: true, suppressAutoSize: false, autoHeight: false, resizable: true }}
                data={publications}
                getRowHeight={() => 60}
                idKey={"id"} searchable={true} tab={""} showHide={[]}
                onRowClicked={handleRowClick}
                cursorHoverOption="pointer"
            />
        </Stack>
    );
}

export default Publications;